module.exports = __webpack_public_path__ + "img/water-droplet-7.7fb29a99.png";